const EmptyLoginLayout = () => import('@/views/Layout/Login/EmptyLoginLayout.vue');
const LoginLayout = () => import('@/views/Layout/Login/LoginLayout.vue');
const SsoLoginPage = () => import('@/views/Pages/Login/SsoLoginPage.vue');
const DirectLoginPage = () => import('@/views/Pages/Login/DirectLoginPage.vue');
const LoginPage = () => import('@/views/Pages/Login/LoginPage.vue');
const InitPasswordForm = () => import('@/views/Pages/Login/Content/InitPasswordForm.vue');
const ResetForm = () => import('@/views/Pages/Login/Content/ResetForm.vue');
const RedirectPage = () => import('@/views/Pages/Login/RedirectPage.vue');

const routes = [
	{
		path: '/',
		name: '',
		redirect: '/login',
		component: LoginLayout,
		children: [
			//로그인 페이지
			{
				path: '/login',
				name: 'Login',
				component: LoginPage
			},

			//비밀번호 초기화 페이지
			{
				path: '/initPassword',
				name: 'InitPassword',
				component: InitPasswordForm
			},

			//비밀번호 변경 페이지
			{
				path: '/reset',
				name: 'Reset',
				component: ResetForm
			}
		]
	},
	//빈 창에서 로그인 처리하여 redirectURL로 이동하기 위한 중간 페이지
	{
		path: '/',
		name: '',
		component: EmptyLoginLayout,
		children: [
			//SSO 로그인 페이지
			{
				path: '/ssoLogin',
				name: 'ssoLogin',
				component: SsoLoginPage
			},
			//Direct 로그인 페이지
			{
				path: '/directLogin',
				name: 'directLogin',
				component: DirectLoginPage
			},	
			//redirect페이지
			{
				path: '/redirect',
				name: 'redirect',
				component: RedirectPage
			}
		]
	}
];

export default routes;
